import { ContentElementCompanyLogoProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: 'text-center',
  imageContainer: 'mx-auto mt-4 mb-6 max-w-[334px] overflow-hidden relative',
  image: 'object-contain w-full max-h-64',
  textBefore: 'body-lg',
  textAfter: 'body-lg',
  socialMediaContainer: 'flex flex-wrap text-black gap-2 justify-center mt-4',
  socialMedia: 'border w-8 h-8 grid place-items-center rounded-full border-current',
} as ContentElementCompanyLogoProps['classProps'];

export default classProps;
